import {LocaleComponentPicker} from '../LocaleComponentPicker'
import {VnContactsExternalLinks} from './vn/VnContactsExternalLinks'

export interface FooterContactsExternalLinksProps {
    classNameVn?: string
}

// Блок с внешними ссылками на способы связи для футера.
export function FooterContactsExternalLinks(props: FooterContactsExternalLinksProps) {

    const {
        classNameVn,
    } = props

    return (
        <LocaleComponentPicker
            vn={<VnContactsExternalLinks className={classNameVn} />}
            demo={<VnContactsExternalLinks className={classNameVn} />}
        />
    )
}
